import { useListBaseTraders, type BaseTrader } from "@/lib/api/trader";

/** The name of a record's trader, from the same trader list ManageCustomers uses. */
export function TraderName({ traderId }: { traderId: string }) {
  const tradersResult = useListBaseTraders();
  if (tradersResult.isLoading) return <span className="text-gray-400">Loading…</span>;

  const traders: BaseTrader[] | null = tradersResult.data?.success ? tradersResult.data.data : null;
  if (!traders) return <span className="text-red-600">Couldn't load traders</span>;

  const trader = traders.find((candidate) => candidate.id === traderId);
  return trader ? <>{trader.name}</> : <span className="text-gray-500">Unknown trader</span>;
}
